import type { ComponentProps } from "react"
import { cn } from "@holigral/shared/ui/lib/utils"

export function Prose({ className, ...props }: ComponentProps<"div">) {
  return (
    <div
      className={cn(
        "prose-h1:font-title prose-h2:font-title prose-h3:font-title prose-ul:[&_::marker]:text-spark-orange/50 prose prose-sm prose-neutral md:prose-base dark:prose-invert prose-ul:list-['◆_']",
        className,
      )}
      {...props}
    />
  )
}

export function H1({ children, className, ...props }: ComponentProps<"h1">) {
  return (
    <Prose className={className}>
      <h1 {...props} className="mb-4!">
        {children}
      </h1>
    </Prose>
  )
}

export function H2({ children, className, ...props }: ComponentProps<"h2">) {
  return (
    <Prose className={className}>
      <h2 {...props}>{children}</h2>
    </Prose>
  )
}
